import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import 'bootstrap/dist/css/bootstrap.min.css';
import { SERVER_BASE } from '../config/server';
import apiClient from '../utils/apiClient';
import Swal from 'sweetalert2';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';

const AddAreaProjects = () => {
  const [ledgerOptions, setLedgerOptions] = useState([]);
  const [formData, setFormData] = useState({
    ledger: null,
    projectName: '',
    projectCode: '',
    approvalNo: '',
    approvalDate: '',
    expectedCompletionDate: '',
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false); // ✅ loading state

  const code = localStorage.getItem('code');
  const name = localStorage.getItem('name');
  const badgeId = localStorage.getItem('badgeId');
  const email = localStorage.getItem('email');
  const location = useLocation();
  const navigate = useNavigate();
  const rowData = location.state?.rowData;

  useEffect(() => {
    if (rowData) {
      setFormData({
        ledger: {
          value: rowData.ledgerId,
          label: rowData.printName,
          ledgerName: rowData.ledgerName,
          state: rowData.state,
          stateCode: rowData.stateCode,
        },
        projectName: rowData.projectName || '',
        projectCode: rowData.projectCode || '',
        approvalNo: rowData.approvalNo || '',
        approvalDate: (rowData.approvalDate ? moment(rowData.approvalDate).format('YYYY-MM-DD') : '') || '',
        expectedCompletionDate: (rowData.expectedCompletionDate ? moment(rowData.expectedCompletionDate).format('YYYY-MM-DD') : '') || '',
      });
    }
  }, [rowData]);

  const fetchLedgers = async () => {
    try {
      const res = await apiClient.get(`${SERVER_BASE}/getLedgersForProjects/${code}`);
  
      const ownCenterOption = {
        value: "Own Center",
        label: "Own Center",
        ledgerName: "Own Center",
        state: null,
        stateCode: null,
      };
  
      const options = res.data.map(ledger => ({
        value: ledger.id,
        label: ledger.printName,
        ledgerName: ledger.ledgerName,
        state: ledger.state,
        stateCode: ledger.stateCode,
      }));
  
      setLedgerOptions([ownCenterOption, ...options]);
    } catch (err) {
      console.error("Failed to fetch ledgers", err);
    }
  };
  

  useEffect(() => {
    fetchLedgers();
  }, [code]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleLedgerChange = (selectedOption) => {
    setFormData(prev => ({ ...prev, ledger: selectedOption }));
  };

  const validate = () => {
    const errs = {};
    if (!formData.ledger) errs.ledger = 'Ledger Name is required';
    if (!formData.projectName.trim()) errs.projectName = 'Project Name is required';
    if (!formData.approvalDate) errs.approvalDate = 'Approval Date is required';
    return errs;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});
    setLoading(true);

    const payload = {
      ledgerId: formData.ledger?.value,
      ledgerName: formData.ledger?.ledgerName,
      printName: formData.ledger?.label,
      projectName: formData.projectName,
      projectCode: formData.projectCode,
      approvalNo: formData.approvalNo,
      approvalDate: formData.approvalDate,
      expectedCompletionDate: formData.expectedCompletionDate,
      createdBy: email,
      state: formData.ledger?.state,
      stateCode: formData.ledger?.stateCode,
      centerCode: code
    };

    try {
      const response = rowData
        ? await apiClient.put(`${SERVER_BASE}/updateAreaProjects/${rowData.id}`, payload)
        : await apiClient.post(`${SERVER_BASE}/saveAreaProjects`, payload);

      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'success',
        title: response?.data?.message,
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
      }).then(() => {
        navigate('../areaProjectList');
      });
    } catch (err) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        title: err?.response?.data?.message || 'Error saving project',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });

    } finally {
      setLoading(false); // ✅ end loading
    }
  };

  return (
    <form className="formcontainer mt-5" onSubmit={handleSubmit}>
      <div className='d-flex gap-3'>
        <button
          className="btn btn-success btn-sm mb-3"
          onClick={() => { navigate('../areaProjectList') }}
        >
          Back
        </button>
        <h5>Area Projects</h5>
      </div>

      <div className='row'>
        <div className="col-md-8">
          <label className="form-label">Ledger Name</label>
          <Select
            options={ledgerOptions}
            value={formData.ledger}
            onChange={handleLedgerChange}
            placeholder="Select Ledger"

          />
          {errors.ledger && <div className="text-danger">{errors.ledger}</div>}
        </div>

        <div className="col-md-4">
          <label className="form-label">Project Name</label>
          <input
            type="text"
            className="form-control"
            name="projectName"
            value={formData.projectName}
            onChange={handleChange}

          />
          {errors.projectName && <div className="text-danger">{errors.projectName}</div>}
        </div>

        <div className="col-md-3">
          <label className="form-label">Project Code</label>
          <input
            type="text"
            className="form-control"
            name="projectCode"
            value={formData.projectCode}
            onChange={handleChange}

          />
        </div>

        <div className="col-md-3">
          <label className="form-label">Approval No.</label>
          <input
            type="text"
            className="form-control"
            name="approvalNo"
            value={formData.approvalNo}
            onChange={handleChange}

          />
        </div>

        <div className="col-md-3">
          <label className="form-label">Approval Date</label>
          <input
            type="date"
            className="form-control"
            name="approvalDate"
            value={formData.approvalDate}
            onChange={handleChange}

          />
          {errors.approvalDate && <div className="text-danger">{errors.approvalDate}</div>}
        </div>

        <div className="col-md-3">
          <label className="form-label">Expected Completion Date</label>
          <input
            type="date"
            className="form-control"
            name="expectedCompletionDate"
            value={formData.expectedCompletionDate}
            onChange={handleChange}

          />
        </div>
      </div>

      <div className="d-flex justify-content-end mt-3">
        <button type="submit" className="btn btn-success" disabled={loading}>
          {loading ? 'Saving...' : 'Submit'}
        </button>
      </div>
    </form>
  );
};

export default AddAreaProjects;
